<template lang="html">
    <section class="update-sub-category">
        <h1>
            Modifiy <span v-for="cat in categoryHierarchy">{{ (action.category.id === cat.id ? "" : " > ") + cat.name }} </span>
        </h1>
        <div>
            <form>
                <div v-if="showMsg">
                    <p style="color: red"><strong>Probleme de mise à jour</strong></p>
                </div>
                <div class="items-category" v-for="(items, key) in action.infoSubCat.terms.name" style="margin: 10px 0;">
                    <label
                        >Sub-category <span class="uppercase">{{ key }}</span> :
                    </label>
                    <input type="text" class="textfield" v-model.trim="items.content" :id="items.id" :name="key" />
                </div>
                <button class="btn" @click.prevent="hideModal">Cancel</button>
                <button type="submit" class="btn" @click.prevent="updateThisSubCat(action);">Modifier</button>
            </form>
        </div>
    </section>
</template>

<script lang="js">
import {mapGetters, mapActions} from 'vuex'
import httpService from '../../../../components/service'

export default {
    name: 'update-sub-category',
    props: [
        'action'
    ],
    mounted () {
    },
    data () {
        return {
            showMsg: false
        }
    },
    created () {
    },
    watch: {},
    methods: {
        ...mapActions({
            listCatBySection: 'categories/listCatBySection'
        }),
        /**
         * Function Update Sub Category
         */
        updateThisSubCat (value) {
            let objValues = Object.values(value.infoSubCat.terms.name).map(v => {
                return {
                    'id': v.id,
                    'content': v.content
                }
            })
            let obj = {
                'name': value.infoSubCat.name,
                'order': value.infoSubCat.order,
                'translations': objValues
            }
            httpService.put('/admin/categories/' + value.infoSubCat.id, JSON.stringify(obj))
                .then((response) => {
                    if (response.success) {
                        this.listCatBySection(value.currentSections)
                        this.showMsg = false
                        this.$root.$emit('bv::hide::modal', 'defaultModal')
                    } else {
                        console.error('...+ERROR UpdateSubCategory+....', response)
                        this.showMsg = true
                    }
                })
        },
        /**
         * Function hide Modal
         */
        hideModal: function () {
            this.$root.$emit('bv::hide::modal', 'defaultModal')
        }
    },
    computed: {
        ...mapGetters({}),
        categoryHierarchy() {
            let cats = [this.action.category];
            while (cats[cats.length - 1].parent) {
                cats.push(cats[cats.length - 1].parent)
            }
            return cats;
        },
    }
}
</script>

<style scoped lang="scss">
.update-sub-category {
}
</style>



// WEBPACK FOOTER //
// UpdateSubCategory.vue?480e3cca